

let headerSlideshow = null;
let teaserSlider = null;
let partnerSlider = null;
let kundenstimmenSlider = null;


if (document.querySelector('.ce_rsce_headerSlideshow')){
    headerSlideshow = new Swiper(".ce_rsce_headerSlideshow", {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: {
            delay: 4500,
            disableOnInteraction: true,
        },
        pagination: {
            el: ".ce_rsce_headerSlideshow .swiper-pagination",
            dynamicBullets: true,
        },
        navigation: {
            nextEl: ".ce_rsce_headerSlideshow .swiper-button-next",
            prevEl: ".ce_rsce_headerSlideshow .swiper-button-prev",
        },
    });

}

if (document.querySelector(".teaserslider")) {
    teaserSlider = new Swiper(".teaserslider .swiper-container", {
        slidesPerView: 3.5,
        spaceBetween: 30,
        loop: true,
        navigation: {
            nextEl: ".teaserslider .swiper-button-next",
            prevEl: ".teaserslider .swiper-button-prev",
        },
        autoplay: {
            delay: 3000,
            disableOnInteraction: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
            600: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1200: {
                slidesPerView: 3.5,
                spaceBetween: 30,
            },
        },
    });
}

if (document.querySelector(".ce_rsce_partnerSlider")) {
    partnerSlider = new Swiper(".ce_rsce_partnerSlider", {
        slidesPerView: 4,
        spaceBetween: 30,
        loop: true,
        autoplay: {
            delay: 40000000000000,
            disableOnInteraction: true,
        },
        navigation: {
            nextEl: ".ce_rsce_partnerSlider .swiper-button-next",
            prevEl: ".ce_rsce_partnerSlider .swiper-button-prev",
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
            600: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 30,
            },
        },
    });
}

if (document.querySelector(".ce_rsce_kundenstimmen")) {
    const kundenstimmenElement = document.querySelector(".ce_rsce_kundenstimmen .slider");
    const kundenstimmenSlides = kundenstimmenElement ? kundenstimmenElement.querySelectorAll(".swiper-slide").length : 0;

    if (kundenstimmenSlides > 0) {
        kundenstimmenSlider = new Swiper(kundenstimmenElement, {
        slidesPerView: 1,
        spaceBetween: 18,
         autoplay: {
            delay: 2000,
            disableOnInteraction: true,
        },
        loop: kundenstimmenSlides > 1,
        watchOverflow: true,
        navigation: {
            nextEl: kundenstimmenElement.querySelector(".swiper-button-next"),
            prevEl: kundenstimmenElement.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 12,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 18,
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 24,
            },
        },
        });
    }
}
